import basicInformationGetters from './basic-information/getters';
import educationGetters from './education/getters';
import languagesGetters from './languages/getters';
import motivatorsGetters from './motivators/getters';
import projectsGetters from './projects/getters';
import skillsGetters from './skills/getters';
import trainingsGetters from './trainings/getters';
import workExperienceGetters from './work-experience/getters';

export default {
  ...basicInformationGetters,
  ...workExperienceGetters,
  ...educationGetters,
  ...projectsGetters,
  ...languagesGetters,
  ...motivatorsGetters,
  ...skillsGetters,
  ...trainingsGetters,
  editProfileLoadingState(state) {
    return state.editProfileLoading;
  },
  partHasChangesState(state) {
    return state.partHasChanges;
  }
};
